// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gesammtunternehmenscreen{
  position: relative;
  /*TEXT FONT*/
  font-family: Inter;
  font-style: normal;
}

.main-content{
  display: flex;
  flex-direction: row;
  gap: 3%;
}

.ziel-left-content{
  margin-left: var(--content-space);
  width: 70%;
}

.ziel-right-content{
  margin-right: var(--content-space);
  margin-top: 20px;
  width: 30%;
}


/* SIDE SELECTOR START*/

.selector-container{
  position: relative;
  display: flex;
  flex-direction: row;
  top: 35px;
  height: fit-content;
  margin-right: 42px;
  margin-left: 42px;
  border-radius: 10px;
  background: var(--searchbar-background);

  /*Text Font*/
  text-align: center;
  /* Inter / 24 sp • H5 */
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
}

.selector-item-selected {
  display: flex;
  align-items: center; /* Center vertically */
  justify-content: center; /* Center horizontally */
  border-radius: 10px;
  cursor: pointer;
  margin: 5px;
  background: var(--white-base);
  width: 100%;
  text-align: center; /* Center text within the flex container */
}

.selector-item-not-selected1 {
  display: flex;
  align-items: center; /* Center vertically */
  justify-content: center; /* Center horizontally */
  border-radius: 10px;
  cursor: pointer;
  margin: 5px;
  width: 100%;
  text-align: center; /* Center text within the flex container */
}
.selector-item-not-selected1:hover {
  background: var(--gray-10);
}

.selector-divider {
  width: 1.48px;
  height: 50.8px;
  background-color: var(--gray-20);
  margin: 10px;
}
/* SIDE SELECTOR END */

/* MAIN CONTENT START*/
.slider-container {
  position: relative;
  margin-top: 80px;
  width: 100%;
  margin-bottom: 118px;
  /* Add vertical gap between children */
  display: flex;
  flex-direction: column;
  gap: 30px;
  border-radius: 10px;
  border: 1px solid var(--border);
  background: var(--white-base);
}
/* MAIN CONTENT END*/



/* SLIDER START */
.slider-header-title-container1{
  position: relative;
  margin: 50px 20px 0px 20px;
  align-items: center;
  display: flex;
  flex-direction: row;
}

.green-button1{  
  border-radius: 18px;
  background: var(--color-forestgreen);
  width: fit-content;
  min-width: 240px;
  height: fit-content;
  cursor: pointer;
  margin-left: auto;
  margin-right: 0px;
  align-self: center;

  /* TEXT FONT*/  
  color: var(--white-base);
  text-align: center;
  /* Inter / 24 sp • H5 */
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 700; 
}
.green-button1:hover{
  transform: scale(1.01);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); 
  transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;
}

.slider-innercontainer1{
  align-self: center;
  margin: 0px 50px 50px 50px;
  width: 90%;
}


.slider-header-container1{
  position: relative;
  display: flex;
  flex-direction: row;  
  justify-content: center;
  align-items: center;
}

.slider-header-container1 {
  display: flex;
  width: fit-content;
  flex-direction: row;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center; 
  margin: 20px auto;
}

.slider-title1{
  /*TEXT FONT*/
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
}

.slider-legend1{
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  align-self: center;

  /*TEXT FONT*/  
  font-size: 16px;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: 0.12px;
}

.slider-legentitem{  
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.slider-legentitem-1{  
  border-radius: 50%;
  background-color: var(--indigo);
  width: 8px;
  height: 8px;
}
.slider-legentitem-2{  
  border-radius: 50%;
  background-color: var(--orange);
  width: 8px;
  height: 8px;
}
.slider-legentitem-3{  
  border-radius: 50%;
  background-color: var(--lime-green);
  width: 8px;
  height: 8px;
}

.slider-jahres-ziel {
  position: relative;
  border-radius: 8px;
  background: var(--white-base);
  display: flex;
  min-width: 50px;
  flex-direction: row;
  align-items: center;
  height: fit-content;
  padding-left: 8px;
  padding-right: 8px;
  margin-left: 10%;
  margin-right: 16px; /* Set a minimum width to prevent overlap */
  /* Shadow */
  box-shadow: 0px 1px 5px 0px var(--white-theme-gray-8);
}

.slider-Zielselection-ziel {
  position: relative;
  border-radius: 8px;
  background: var(--white-base);
  display: flex;
  flex-direction: row;
  align-items: center;
  height: fit-content;
  min-width: 160px;
  padding-left: 8px;
  margin-left: 50px;
  /* Shadow */
  box-shadow: 0px 1px 5px 0px var(--white-theme-gray-8);
}

.ziel-slider-filterimg{
  position: relative;
  margin-left: 10px;
}

.slider-title-smaller-ziel {
  margin-top: 20px;
  margin-bottom: 50px;
  font-size: 20px;
  font-weight: 600;
  line-height: 32px;
}

.slider-card {
  position: relative;
  height: fit-content;
  width: 100%;
  margin-top: 30px;

  border-radius: 10px;
  border: 1px solid var(--border);
  background: var(--white-base);
}

.slider-card-container-ziel{
  margin: 0px 70px 100px 70px;
}
/* SLIDER END */


/* DIGITAL INDEX RADIALCHART START */
.di-box1{
  margin-top: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  border: 1px solid var(--border);

  /* TEXT FONT*/
  font-family: Inter;
  font-style: normal;
}
.di-title1{
  margin: 15px 0px;
  text-align: center;

  /* TEXT FONT*/
  font-size: 34px;
  font-weight: 700;
  line-height: 44px;
  letter-spacing: -0.56px;
}
.di-content1{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0px 20px;
  justify-content: center;
}


.di-info-title1{
  margin-left: 20px;
  font-weight: 600;
  line-height: 32px;
  margin-right: auto;
  /* TEXT FONT */  
  font-size: 25px;
}

.di-legend1{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 20px;

  /* TEXT FONT */  
  font-size: 16px;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: 0.12px;
}

.di-info-text1{
  margin: 0px 20px;
}

.gesammt-info1{
  margin: 20px;
  width: 100%;
  height: fit-content;
  border-radius: 12px;
}

.radialchart-zielsetzung {
  position: relative;
  display: flex;
  width: 100%;
  justify-content: center; /* horizontally center the child */
  align-self: center; /* vertically center the child */
}

/* DIGITAL INDEX RADIALCHART END */`, "",{"version":3,"sources":["webpack://./src/pages/StrategieZieldimensionen.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;AACT;;AAEA;EACE,iCAAiC;EACjC,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,UAAU;AACZ;;;AAGA,uBAAuB;;AAEvB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;;EAEvC,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,sBAAsB;EAC3C,uBAAuB,EAAE,wBAAwB;EACjD,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,6BAA6B;EAC7B,WAAW;EACX,kBAAkB,EAAE,0CAA0C;AAChE;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,sBAAsB;EAC3C,uBAAuB,EAAE,wBAAwB;EACjD,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,WAAW;EACX,kBAAkB,EAAE,0CAA0C;AAChE;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gCAAgC;EAChC,YAAY;AACd;AACA,sBAAsB;;AAEtB,sBAAsB;AACtB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;AAC/B;AACA,oBAAoB;;;;AAIpB,iBAAiB;AACjB;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;;EAElB,aAAa;EACb,wBAAwB;EACxB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,wCAAwC;EACxC,iFAAiF;AACnF;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,UAAU;AACZ;;;AAGA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;;EAEnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;;EAElB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,UAAU;EACV,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,UAAU;EACV,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB,EAAE,2CAA2C;EAC/D,WAAW;EACX,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;;EAEhB,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;AACA,eAAe;;;AAGf,oCAAoC;AACpC;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;;EAE/B,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;;EAElB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;;AAGA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;;EAEnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,uBAAuB,EAAE,kCAAkC;EAC3D,kBAAkB,EAAE,gCAAgC;AACtD;;AAEA,kCAAkC","sourcesContent":[".gesammtunternehmenscreen{\r\n  position: relative;\r\n  /*TEXT FONT*/\r\n  font-family: Inter;\r\n  font-style: normal;\r\n}\r\n\r\n.main-content{\r\n  display: flex;\r\n  flex-direction: row;\r\n  gap: 3%;\r\n}\r\n\r\n.ziel-left-content{\r\n  margin-left: var(--content-space);\r\n  width: 70%;\r\n}\r\n\r\n.ziel-right-content{\r\n  margin-right: var(--content-space);\r\n  margin-top: 20px;\r\n  width: 30%;\r\n}\r\n\r\n\r\n/* SIDE SELECTOR START*/\r\n\r\n.selector-container{\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: row;\r\n  top: 35px;\r\n  height: fit-content;\r\n  margin-right: 42px;\r\n  margin-left: 42px;\r\n  border-radius: 10px;\r\n  background: var(--searchbar-background);\r\n\r\n  /*Text Font*/\r\n  text-align: center;\r\n  /* Inter / 24 sp • H5 */\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n  line-height: 36px;\r\n}\r\n\r\n.selector-item-selected {\r\n  display: flex;\r\n  align-items: center; /* Center vertically */\r\n  justify-content: center; /* Center horizontally */\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  margin: 5px;\r\n  background: var(--white-base);\r\n  width: 100%;\r\n  text-align: center; /* Center text within the flex container */\r\n}\r\n\r\n.selector-item-not-selected1 {\r\n  display: flex;\r\n  align-items: center; /* Center vertically */\r\n  justify-content: center; /* Center horizontally */\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  margin: 5px;\r\n  width: 100%;\r\n  text-align: center; /* Center text within the flex container */\r\n}\r\n.selector-item-not-selected1:hover {\r\n  background: var(--gray-10);\r\n}\r\n\r\n.selector-divider {\r\n  width: 1.48px;\r\n  height: 50.8px;\r\n  background-color: var(--gray-20);\r\n  margin: 10px;\r\n}\r\n/* SIDE SELECTOR END */\r\n\r\n/* MAIN CONTENT START*/\r\n.slider-container {\r\n  position: relative;\r\n  margin-top: 80px;\r\n  width: 100%;\r\n  margin-bottom: 118px;\r\n  /* Add vertical gap between children */\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 30px;\r\n  border-radius: 10px;\r\n  border: 1px solid var(--border);\r\n  background: var(--white-base);\r\n}\r\n/* MAIN CONTENT END*/\r\n\r\n\r\n\r\n/* SLIDER START */\r\n.slider-header-title-container1{\r\n  position: relative;\r\n  margin: 50px 20px 0px 20px;\r\n  align-items: center;\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n\r\n.green-button1{  \r\n  border-radius: 18px;\r\n  background: var(--color-forestgreen);\r\n  width: fit-content;\r\n  min-width: 240px;\r\n  height: fit-content;\r\n  cursor: pointer;\r\n  margin-left: auto;\r\n  margin-right: 0px;\r\n  align-self: center;\r\n\r\n  /* TEXT FONT*/  \r\n  color: var(--white-base);\r\n  text-align: center;\r\n  /* Inter / 24 sp • H5 */\r\n  font-family: Inter;\r\n  font-size: 20px;\r\n  font-style: normal;\r\n  font-weight: 700; \r\n}\r\n.green-button1:hover{\r\n  transform: scale(1.01);\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); \r\n  transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;\r\n}\r\n\r\n.slider-innercontainer1{\r\n  align-self: center;\r\n  margin: 0px 50px 50px 50px;\r\n  width: 90%;\r\n}\r\n\r\n\r\n.slider-header-container1{\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: row;  \r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.slider-header-container1 {\r\n  display: flex;\r\n  width: fit-content;\r\n  flex-direction: row;\r\n\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  justify-content: center; \r\n  margin: 20px auto;\r\n}\r\n\r\n.slider-title1{\r\n  /*TEXT FONT*/\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n  line-height: 36px;\r\n}\r\n\r\n.slider-legend1{\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  gap: 20px;\r\n  align-self: center;\r\n\r\n  /*TEXT FONT*/  \r\n  font-size: 16px;\r\n  font-weight: 400;\r\n  line-height: 24px; /* 150% */\r\n  letter-spacing: 0.12px;\r\n}\r\n\r\n.slider-legentitem{  \r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.slider-legentitem-1{  \r\n  border-radius: 50%;\r\n  background-color: var(--indigo);\r\n  width: 8px;\r\n  height: 8px;\r\n}\r\n.slider-legentitem-2{  \r\n  border-radius: 50%;\r\n  background-color: var(--orange);\r\n  width: 8px;\r\n  height: 8px;\r\n}\r\n.slider-legentitem-3{  \r\n  border-radius: 50%;\r\n  background-color: var(--lime-green);\r\n  width: 8px;\r\n  height: 8px;\r\n}\r\n\r\n.slider-jahres-ziel {\r\n  position: relative;\r\n  border-radius: 8px;\r\n  background: var(--white-base);\r\n  display: flex;\r\n  min-width: 50px;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  height: fit-content;\r\n  padding-left: 8px;\r\n  padding-right: 8px;\r\n  margin-left: 10%;\r\n  margin-right: 16px; /* Set a minimum width to prevent overlap */\r\n  /* Shadow */\r\n  box-shadow: 0px 1px 5px 0px var(--white-theme-gray-8);\r\n}\r\n\r\n.slider-Zielselection-ziel {\r\n  position: relative;\r\n  border-radius: 8px;\r\n  background: var(--white-base);\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  height: fit-content;\r\n  min-width: 160px;\r\n  padding-left: 8px;\r\n  margin-left: 50px;\r\n  /* Shadow */\r\n  box-shadow: 0px 1px 5px 0px var(--white-theme-gray-8);\r\n}\r\n\r\n.ziel-slider-filterimg{\r\n  position: relative;\r\n  margin-left: 10px;\r\n}\r\n\r\n.slider-title-smaller-ziel {\r\n  margin-top: 20px;\r\n  margin-bottom: 50px;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  line-height: 32px;\r\n}\r\n\r\n.slider-card {\r\n  position: relative;\r\n  height: fit-content;\r\n  width: 100%;\r\n  margin-top: 30px;\r\n\r\n  border-radius: 10px;\r\n  border: 1px solid var(--border);\r\n  background: var(--white-base);\r\n}\r\n\r\n.slider-card-container-ziel{\r\n  margin: 0px 70px 100px 70px;\r\n}\r\n/* SLIDER END */\r\n\r\n\r\n/* DIGITAL INDEX RADIALCHART START */\r\n.di-box1{\r\n  margin-top: 60px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 12px;\r\n  border: 1px solid var(--border);\r\n\r\n  /* TEXT FONT*/\r\n  font-family: Inter;\r\n  font-style: normal;\r\n}\r\n.di-title1{\r\n  margin: 15px 0px;\r\n  text-align: center;\r\n\r\n  /* TEXT FONT*/\r\n  font-size: 34px;\r\n  font-weight: 700;\r\n  line-height: 44px;\r\n  letter-spacing: -0.56px;\r\n}\r\n.di-content1{\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  margin: 0px 20px;\r\n  justify-content: center;\r\n}\r\n\r\n\r\n.di-info-title1{\r\n  margin-left: 20px;\r\n  font-weight: 600;\r\n  line-height: 32px;\r\n  margin-right: auto;\r\n  /* TEXT FONT */  \r\n  font-size: 25px;\r\n}\r\n\r\n.di-legend1{\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 10px;\r\n  margin-bottom: 20px;\r\n\r\n  /* TEXT FONT */  \r\n  font-size: 16px;\r\n  font-weight: 400;\r\n  line-height: 24px; /* 150% */\r\n  letter-spacing: 0.12px;\r\n}\r\n\r\n.di-info-text1{\r\n  margin: 0px 20px;\r\n}\r\n\r\n.gesammt-info1{\r\n  margin: 20px;\r\n  width: 100%;\r\n  height: fit-content;\r\n  border-radius: 12px;\r\n}\r\n\r\n.radialchart-zielsetzung {\r\n  position: relative;\r\n  display: flex;\r\n  width: 100%;\r\n  justify-content: center; /* horizontally center the child */\r\n  align-self: center; /* vertically center the child */\r\n}\r\n\r\n/* DIGITAL INDEX RADIALCHART END */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
